import {
    FETCH_VOICEMAILS_SUCCESS,
    FETCH_VOICEMAILS_ERROR,
    FETCH_VOICEMAILS_LOADING,

    RESET_VOICEMAILS,
    FETCH_MORE_VOICEMAILS_SUCCESS,
    FETCH_MORE_VOICEMAILS_LOADING,
    SET_VOICECHAT_PHONE_NO,
    FETCH_VOICECHAT_LOADING,
    FETCH_VOICECHAT_SUCCESS,
    FETCH_VOICECHAT_ERROR,

    UPDATE_NOTES_VOICEMAIL,
    FETCH_VOICECHAT_UNREAD_COUNT_SUCCESS
} from "./index" 

import {apiCall, platform} from "../../functions/utils"

export const fetchVoicemailsSuccess = (data) => {
    return {
        type : FETCH_VOICEMAILS_SUCCESS,
        payload: data.data,
        meta: data.meta
    }
}

export const fetchMoreVoicemailsSuccess = (data) => {
    return {
        type : FETCH_MORE_VOICEMAILS_SUCCESS,
        payload: data.data,
        meta: data.meta
    }
}

export const fetchVoicemailsError = (error) => {
    return {
        type : FETCH_VOICEMAILS_ERROR,
        error
    }
}



export const fetchVoicemailsLoading = () => {
    return {
        type : FETCH_VOICEMAILS_LOADING
    }
}

export const resetVoicemails = () => {
    return {
        type : RESET_VOICEMAILS
    }
}

export const fetchMoreVoicemails = (meta = false) => {  
    return async (dispatch, getState) => {
        let page = 1;
        if( !meta ){
            meta = getState().voicemails.meta
        }
        if(meta){
            if( meta.current_page < meta.last_page){
                page = meta.current_page + 1 
                dispatch({
                    type : FETCH_MORE_VOICEMAILS_LOADING
                })
                try{
                    const res = await apiCall(true, "GET", `/api/voicemails?page=${page}`)
                    dispatch(fetchMoreVoicemailsSuccess(res.data))
                }catch(e){
                    dispatch(fetchVoicemailsError(e))
                } 
            }
        }
    } 
}

export const fetchVoiceUnReadCountData = () => {
    return async (dispatch) => {
        const res = await apiCall(true, "GET", `/api/voicemails/unread-count`)
        dispatch({
            type : FETCH_VOICECHAT_UNREAD_COUNT_SUCCESS,
            payload: res.data.data,
        })  
    }
}

export const fetchVoicemails = (page = 1) => {
    return async (dispatch, getState) => {
        dispatch(fetchVoicemailsLoading())
        try{
            const res = await apiCall(true, "GET", `/api/voicemails?page=${page}`)
            dispatch(fetchVoicemailsSuccess(res.data))
            dispatch(fetchVoiceUnReadCountData())
            if( !getState().voicemails.chat_phone_no ){
                dispatch(setVoiceChatPhone(res.data.data[0].sender_phone))
                dispatch(fetchVoiceChat())
            }
        }catch(e){
            dispatch(fetchVoicemailsError(e))
        } 
    }
}

export const fetchAllVoicemailsSilently = () =>{
    return async (dispatch, getState) => {
        let accounts = getState().authUser.user?.accounts
        if( accounts ){
            accounts.forEach(account => {
                dispatch(fetchSilentVoicemails(1, account.id))
            });   
        }
    }
}

//  f_consider
//  fetch silent would be without this
export const fetchSilentVoicemails = (page = 1, accountId = false) => {
    return async (dispatch, getState) => {
        // dispatch(fetchMessagesLoading())
        try{
            let res
            if( accountId ){
                res = await apiCall(true, "GET", `/api/voicemails?page=${page}`, {}, true, true, false, accountId)
            }else{
                res = await apiCall(true, "GET", `/api/voicemails?page=${page}`)
            }
            if( accountId && getState().authUser.activeAccount != accountId ){
                // dispatch(fetchAllMessagesSuccess(res.data, getState(), accountId))
            }else{
                dispatch(fetchVoicemailsSuccess(res.data))
                dispatch(fetchVoiceUnReadCountData())
            }
            
        }catch(e){
            dispatch(fetchVoicemailsError(e))
        } 
    }
}

export const setVoiceChatPhone = (phone) =>{  
    return {
        type : SET_VOICECHAT_PHONE_NO,
        payload: phone
    }
}

export const fetchVoiceChat = () => {
    return async (dispatch, getState) => {
        console.log("fetchChat", getState());
        dispatch(fetchVoiceChatLoading())
        try{
            if( getState().voicemails.chat_phone_no ){
                const res = await apiCall(true, "POST", `/api/voicemails/individual-info`, {
                    contact_id_or_phone: getState().voicemails.chat_phone_no,
                    type: 'new_number'
                })
                console.log("fetchVOICECHAT", res.data);
                dispatch(fetchVoiceChatSuccess(res.data))
            }
        }catch(e){
            dispatch(fetchVoiceChatError(e))
        } 
    }
}

export const fetchSilentVoiceChat = () => {
    return async (dispatch, getState) => {
        try{
            if( getState().voicemails.chat_phone_no ){
                const res = await apiCall(true, "POST", `/api/voicemails/individual-info`, {
                    contact_id_or_phone: getState().voicemails.chat_phone_no,
                    type: 'new_number'
                })
                console.log("fetchVOICECHAT", res.data);
                dispatch(fetchVoiceChatSuccess(res.data))
            }
        }catch(e){
            dispatch(fetchVoiceChatError(e))
        } 
    }
}

export const fetchVoiceChatSuccess = (data) => {
    return {
        type : FETCH_VOICECHAT_SUCCESS,
        payload: platform == "mobile" ? data.data : data.data.reverse(),
        meta: data.meta
    }
}

export const fetchVoiceChatError = (error) => {
    console.log("fetchVoiceChatError", error);
    return {
        type : FETCH_VOICECHAT_ERROR,
        error
    }
}

export const fetchVoiceChatLoading = () => {
    return {
        type : FETCH_VOICECHAT_LOADING
    }
}

export const UpdateNotesVoicemail = ( input, item ) => {
    return {
        type : UPDATE_NOTES_VOICEMAIL,
        payload: {
            note: input.value,
            id: item.id
        }
    }
}

export const unreadVoiceChat = (phone) => {
    return async (dispatch, getState) => {
        let formData = {};
        formData.phone = phone;
        const res = await apiCall(true, "POST", `/api/voicemails/unread`, formData);
    }
}

export const triggerVoiceChatPush = () => {
    return async (dispatch, getState) => {
        const res = await apiCall(true, "GET", `/api/voicemails/triggerPush`);
    }
}
export const changeVoiceReadStatus = (id) => {
    return async (dispatch, getState) => {
        const res = await apiCall(true, "GET", `/api/voicemails/change-status/${id}`);
    }
}
export const deleteVoiceChat = (sender_phone) => {
    return async (dispatch, getState) => {
        let formData = {
            contact_id_or_phone_no: sender_phone,
            type: "phone_no",
        }
        const res = await apiCall(true, "POST", `/api/voicemails/delete-all`, formData);
    }
}
